import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import getLabel from './../../../../utils/labels'
import styles from "./displayActorEmails.module.scss";

class DisplayActorEmails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isHovered: false,
			currentActorId: -1
		};
	}

	getActorDetailsOnHover = actor => {
		return (
			<ReactTooltip className={styles.actorcard}>
				<div className="node-contents" style={{ padding: "0" }}>
					<div className="image-container">
						<img className="node-image" src={actor.gravatar} />
					</div>
					<div className="text">
						<div className="name">
							{`${actor.first_name} ${actor.last_name}`}
						</div>
						<div>
							{actor.role}
							{actor.company ? "," : null}
						</div>
						<div>{actor.company}</div>
					</div>
				</div>
			</ReactTooltip>
		);
	};

	setIsHoveredFlag = id => {
		this.setState({
			isHovered: true,
			currentActorId: id
		});
	};

	removeIsHoveredFlag = () => {
		this.setState({
			isHovered: false,
			currentActorId: -1
		});
	};

	getActorEmails = receiverType => {
		let { data } = this.props;
		let { isHovered, currentActorId } = this.state;
		return data.map((item, key) => {
			if (item.type === receiverType) {
				return (
					<div
						key={key}
						className={styles.actor}
						onMouseEnter={() =>
							this.setIsHoveredFlag(item.details.id)
						}
						onMouseLeave={() => this.removeIsHoveredFlag()}
						data-tip="React-tooltip"
					>
						{`${item.details.first_name} ${
							item.details.last_name
							} (${item.details.email})`}
						{isHovered && item.details.id === currentActorId
							? this.getActorDetailsOnHover(item.details)
							: null}
					</div>
				);
			}
		});
	};

	render() {
		let { data } = this.props;
		let toActor = data.some(item => item.type === "to");
		let ccActor = data.some(item => item.type === "cc");

		return (
			<div className={styles.container}>
				{toActor ? (
					<div style={{ display: "flex" }}>
						<div style={{ marginRight: "3px" }}>{getLabel('label_to_small')}</div>
						<div style={{ lineHeight: "1.4" }}>
							{this.getActorEmails("to")}
						</div>
					</div>
				) : null}
				{ccActor ? (
					<div
						style={
							toActor
								? { marginTop: "16px", display: "flex" }
								: { display: "flex" }
						}
					>
						<div style={{ marginRight: "3px" }}>{getLabel('label_cc_small')}</div>
						<div style={{ lineHeight: "1.4" }}>
							{this.getActorEmails("cc")}
						</div>
					</div>
				) : null}
			</div>
		);
	}
}

export default DisplayActorEmails;



// WEBPACK FOOTER //
// /src/components/mailThread/mail/displayActorEmails/DisplayActorEmails.js